// extracted by mini-css-extract-plugin
export var cartContainer = "_ij-4";
export var gray = "_ij-1";
export var itemContainer = "_ij-2";
export var itemDetails = "_ij-3";
export var strong = "_ij-0";